<template>

  <div style="position: relative">
    <topInfo title="我的待办" :name="name" :todo-number="todoNumber"></topInfo>
    <search ref="search" type-value="todo" :show-person-filter="true" :isMultiple.sync="isPiLiang" @refreshList="search" @select="selectSearch" @changeShow="changeShow" @clearResult="clearResult"></search>
    <div class="content" ref="targetElement" style="overflow: auto;" @scroll="handleScroll">
      <div :style="{ height: scrollHeight + 'px' }">
        <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
          <van-list v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad">
            <van-checkbox-group v-model="result">
              <div class="content-item" v-for="(item, index) in dataList" :key="index" @click="jump(item, index)">
                <div v-if="isPiLiang === true" style="margin-left: 5px; width: 20px; display: flex; align-items: center">
                  <van-checkbox ref="checkbox" shape="square" :name="item" :disabled="item.businessTable === 'wuye_infacy_main' || item.isMobile === '0'"></van-checkbox>
                </div>
                <div class="content-item-user">
                  <div class="avatar">
                    <span id="avatarText">{{ sliceName(item.createName) }}</span>
                  </div>
                  <div class="content-item-user-name">{{ item.createName }}</div>
                </div>
                <div class="content-item-center">
                  <div class="content-item-center-title">
                    {{ item.name.replace(/[_＿\-\s](总公司|常州公司|常州子公司|无锡公司|无锡子公司)/g, '') }}
                  </div>
                  <div class="content-item-center-content">
                    {{ item.title }}
                  </div>
                  <div class="content-item-center-tips">
                    <div class="content-item-center-tips-days">
                      已停留 <span :class="changeColor(item.durationTime)">{{ item.durationTime || zeroTime }}</span>
                    </div>
                    <div class="content-item-right">
                      <div class="content-item-right-date">
                        {{ item.createDate.slice(0, 10) }}
                      </div>
                      <div style="font-size: 14px; margin-top: 5px">
                        {{ item.createDate.slice(10) }}
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </van-checkbox-group>

<!--            <div class="content-item" v-for="(item, index) in dataList" :key="index" @click="jump(item)">-->
<!--                <div class="content-item-user">-->
<!--                  <div class="avatar">-->
<!--                    <span id="avatarText">{{ sliceName(item.createName) }}</span>-->
<!--                  </div>-->
<!--                  <div class="content-item-user-name">{{ item.createName }}</div>-->
<!--                </div>-->
<!--                <div class="content-item-center">-->
<!--                  <div class="content-item-center-title">-->
<!--                    {{ item.name }}-->
<!--                  </div>-->
<!--                  <div class="content-item-center-content">-->
<!--                    {{ item.title }}-->
<!--                  </div>-->
<!--                  <div class="content-item-center-tips">-->
<!--                    <div class="content-item-center-tips-days">-->
<!--                      已停留 <span :class="changeColor(item.durationTime)">{{ item.durationTime || zeroTime }}</span>-->
<!--                    </div>-->
<!--                    <div class="content-item-right">-->
<!--                      <div class="content-item-right-date">-->
<!--                        {{ item.createDate.slice(0, 10) }}-->
<!--                      </div>-->
<!--                      <div style="font-size: 14px; margin-top: 5px">-->
<!--                        {{ item.createDate.slice(10) }}-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                </div>-->

<!--              </div>-->
          </van-list>
        </van-pull-refresh>
      </div>
    </div>

    <van-dialog v-model="approvalShow" title="审批" show-cancel-button @confirm="submitTask" :beforeClose="beforeClose">
      <div class="doTask1">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" @input="isMessage=false" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div v-if="isMessage" style="color: red">请输入审核意见</div>
<!--        <div style="text-align:center">-->
<!--          <van-button type="info" size="small" style="width: 100%;margin-top: 2%;" @click="submitTask()">提交</van-button>-->
<!--        </div>-->
      </div>
    </van-dialog>

    <van-dialog v-model="resultDialog" title="" @confirm="showResult">
      <div style="width: 100%; height: 80px; text-align: center; line-height: 80px;">
        批量审批成功了<span style="color: rgb(0,0,255)"> {{successNum}} </span>条,失败了<span style="color: rgb(255,0,0)"> {{errNum}} </span>条
      </div>
    </van-dialog>

    <van-popup v-model="progressShow">
       <div style="width: 200px; height: 100px; display: flex; flex-direction: column; justify-content: space-evenly; align-items: center">
         <div>
           <van-loading type="spinner" >加载中...</van-loading>
         </div>
         <div style="width: 90%">
           <van-progress :percentage="percentage" />
         </div>
       </div>
    </van-popup>

    <div class="selectMul" v-if="isPiLiang">
      <div style="font-size: 15px; flex: 1">已选择({{this.result.length}}/{{total}})条</div>
      <div style="flex: 1; text-align: center">
        <span style="color: #0093FF; font-size: 18px; font-weight: bold;" @click="showApproval">批量审批</span>
<!--        <van-button type="info" size="normal" :disabled="result.length === 0" @click="showApproval">批量审批</van-button>-->
      </div>
      <div style="flex: 1; text-align: right; font-size: 15px; height: 50px; line-height: 50px; padding-right: 20px" @touchstart="cancelMultiple"> 取消 </div>
    </div>
    <div v-else class="confirm" @touchstart="changeMultipule">批量处理</div>

  </div>
</template>

<script>
import Vue from "vue";
import search from "../../../components/search/search";
import topInfo from "../../../components/topInfo/topInfo";
import FlowSettingService from "../../../api/sys/flowSettingService";
import URLS from "../../../utils/URL";
import TaskService from "../../../api/flowable/TaskService";
import auditService from '@/api/mater/auditService'
import ProcessService from '@/api/flowable/ProcessService'
export default {
  name: "todo",
  data() {
    return {
      value: "", // 搜索框查询字段
      category:'', // 全部分类查询字段
      businessTable: '',
      businessName: '',
      show: false,
      token: Vue.cookie.get('token'),
      name: Vue.cookie.get('name'),
      isLoading: false,
      loading: false,
      finished: false,
      flowSettingService: null,
      dataList: [],
      current: 0,
      size: 10,
      total: '',
      error: false,
      todoNumber: 0,
      zeroTime: '0分',
      isScroll: false,
      scrollHeight: 0,
      result: [],
      isPiLiang: false,
      approvalShow: false,
      progressShow: false,
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      percentage: 0,
      isMessage: false,
      errNum: 0,
      successNum: 0,
      resultDialog: false,
    }
  },
  components: {
    search,
    topInfo
  },
  created() {
    this.flowSettingService = new FlowSettingService()
    // this.refreshList()
    // var position = '1500px';
    // if (position) {
    //   this.$nextTick(()=> {
    //     console.log(document.querySelector('.content'))
    //     document.querySelector('.content').scrollTo({
    //       top: position,
    //       behavior: 'smooth' // 如果你想要平滑滚动的效果
    //     }); // 恢复滚动位置
    //   })
    // }
    this.onLoad()
  },
  // activated() {
  //
  // },
  mounted() {
    // let target = document.querySelector('.content');
    // target.addEventListener('scroll', ()=>{
    //   let scrollTopPosition = target.scrollTop;
    //   localStorage.setItem('scrollTopPosition', scrollTopPosition);
    // })
    if(localStorage.getItem('scrollTopPosition')) {
      this.scrollToPosition()
    }
  },
  watch: {
    // isPiLiang(newValue, oldValue) {
    //   if(newValue) {
    //     document.documentElement.style.setProperty('--dynamic-height', '50px');
    //   } else {
    //     document.documentElement.style.setProperty('--dynamic-height', '0px');
    //   }
    // }
  },
  methods: {
    handleScroll(event) {
      // 在这里处理滚动事件
      // if(this.size === 10) {
        this.isScroll = true
        localStorage.setItem('scrollTopPosition', event.target.scrollTop);
      // }
      // console.log("滚动值:", event.target.scrollTop);
    },
    scrollToPosition() {
      // 滚动到特定位置，例如滚动到500px的位置
      this.$refs.targetElement.scrollTo({
        top: localStorage.getItem('scrollTopPosition'),
        // behavior: 'smooth' // 使用平滑滚动效果
      });
      this.current = Number(localStorage.getItem('current'))
      // localStorage.removeItem('current')
      // localStorage.removeItem('scrollTopPosition')
      // this.size = 10
      // this.finished = this.total / this.size <= this.current
    },
    onRefresh() {
      this.dataList = []
      this.current = 1
      this.size = 10
      this.result = []
      // this.value = Vue.cookie.get('searchName') || ''
      // this.category = ''
      // this.$refs.search.activeId = ''
      // this.$refs.search.value = ''
      // this.$refs.search.searchTitle = '系统分类'
      this.refreshList()
      this.isLoading = false;
    },
    search(value) {
      this.value = value
      this.dataList = []
      this.current = 1
      this.size = 10
      this.refreshList()
      this.isLoading = false;
    },
    selectSearch(data){
      this.category = data.name
      this.businessTable = data.businessTable
      this.businessName = data.businessName
      localStorage.setItem('category', data.name || '')
      localStorage.setItem('businessTable', data.businessTable || '')
      localStorage.setItem('businessName', data.businessName || '')
      this.dataList = []
      this.current = 1
      this.size = 10
      this.refreshList()
      this.isLoading = false;
    },
    onLoad() {
      let current = Number(localStorage.getItem('current'))
      if(!this.isScroll && current) {
        this.current = 1
        this.size = 10 * current
      } else {
        this.current += 1
        this.size = 10
      }
      localStorage.setItem('size', this.size)
      localStorage.setItem('current', this.current)
      this.loading = true
      if(Vue.cookie.get('todoSearchValue')) {
        this.value = Vue.cookie.get('todoSearchValue')
        this.$nextTick(()=>{
          this.$refs.search.value = this.value
        })
      }
      if(Vue.cookie.get('searchTitle')) {
        this.$nextTick(()=>{
          this.$refs.search.searchTitle = Vue.cookie.get('searchTitle')
          this.$refs.search.activeId = Vue.cookie.get('searchTitleId')
        })
        this.category = Vue.cookie.get('searchTitle')
      }
      if(localStorage.getItem('businessName')) {
       this.category = localStorage.getItem('category')
       this.businessTable = localStorage.getItem('businessTable')
       this.businessName = localStorage.getItem('businessName')
        this.$nextTick(()=>{
          this.$refs.search.name = this.category || ''
          this.$refs.search.searchTitle = this.businessName || ''
          this.$refs.search.businessName = this.businessName || ''
          this.$refs.search.businessTable = this.businessTable || ''
        })
      }
      this.$toast.loading({ forbidClick: true, message: '数据加载中', duration: 0 })
      this.flowSettingService.queryToDoList({
        current: this.current,
        size: this.size,
        title: this.value,
        type: this.category,
        businessTable: this.businessTable,
        businessName: this.businessName
      }).then(({data}) => {
        this.dataList.push(...data.records)
        this.total = data.total
        this.loading = false
        this.finished = this.total / this.size <= this.current
        this.error = false
        this.$toast.clear()
        this.queryTodoNumber()
        let size = localStorage.getItem('size')
        if(size > 10) {
          this.current = size / 10
          localStorage.setItem('current', this.current)
        }
        if(!this.isScroll && localStorage.getItem('scrollTopPosition')) {
          this.scrollHeight = this.dataList.length * 110
          setTimeout(()=>{
            this.scrollToPosition()
          }, 500)
        } else {
          this.scrollHeight =  this.dataList.length * 110
        }
      }).catch(() => {
        this.loading = false
        this.error = true
        this.current--
        this.$toast.clear()
      })
    },
    refreshList() {
      this.$toast.loading({ forbidClick: true, message: '数据加载中', duration: 0 })
      this.flowSettingService.queryToDoList({
        current: this.current,
        size: this.size,
        title: this.value,
        type: this.category,
        businessTable: this.businessTable,
        businessName: this.businessName
      }).then(({data}) => {
        this.dataList = data.records
        this.total = data.total
        this.finished = this.total / this.size <= this.current
        this.$toast.clear()
        this.queryTodoNumber()
        this.$nextTick(()=>{
          this.$refs.search.init()
        })
        this.scrollHeight = this.dataList.length * 110
        setTimeout(()=> {
          this.$refs.targetElement.scrollTo({
            top: 0,
            behavior: 'smooth' // 使用平滑滚动效果
          });
        }, 0)
      }).catch(() => {
        this.loading = false
        this.error = true
        this.current--
        this.$toast.clear()
      })
    },
    init(value) {
      this.flowSettingService.queryToDoList({
        current: this.current,
        size: this.size,
        title: '',
        category: this.category,
        businessTable: this.businessTable
      }).then(({data}) => {
        this.dataList = data.records
        this.total = data.total
        this.finished = this.total / this.size <= this.current
        if (!this.finished) {
          this.current += 1
        }
      }).catch(() => {
        this.loading = false
        this.error = true
        this.current--
      })
    },
    queryTodoNumber(){
       this.flowSettingService.queryRightData({
         userId: Vue.cookie.get('userId')
       }).then(({data}) => {
         this.todoNumber = data
       })
    },
    jump(data, index){
      if(!this.show && !this.isPiLiang) {
        if(data.isMobile === '0') {
          this.$toast.fail('请使用电脑端进行审批！');
          return
        }
        if(data.businessTable === 'its_contract') {
          switch (data.formKey) {
            case '/its/contract/ItsContractCustomsAffairFormFlow':
              this.$router.push({
                path: '/ItsContractCustomsAffair',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractLaborFlowForm':
              this.$router.push({
                path: '/ItsContractLabor',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractAgencyFormFlow':
              this.$router.push({
                path: '/ItsContractAgency',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
                  break
            case '/its/contract/ItsContractPurchaseFormFlow':
              this.$router.push({
                path: '/ItsContractPurchase',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractCarrierFormFlow':
              this.$router.push({
                path: '/ItsContractCarrier',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractRentColdFormFlow':
              this.$router.push({
                path: '/ItsContractRentCold',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractRentPackFormFlow':
              this.$router.push({
                path: '/ItsContractRentPack',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractCustomsInspectFormFlow':
              this.$router.push({
                path: '/ItsContractCustomsInspect',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })

              break
            case '/its/contract/ItsContractCustomsApplyFormFlow':
              this.$router.push({
                path: '/ItsContractCustomsApply',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractSalesFormFlow':
              this.$router.push({
                path: '/ItsContractSalesFormFlow',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            default :
              this.$router.push({
                path: '/' + data.businessTable,
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
          }

          return
        }
        if(data.businessTable !== '') {
          this.$router.push({
            path: '/' + data.businessTable,
            query: {
              id: data.businessId,
              procInsId: data.procInsId,
              taskId: data.taskId,
              taskDefKey: data.taskDefKey,
              procDefId: data.procDefId,
              type: 'todo',
              businessTable:data.businessTable,
              projectType: data.type || ''
            }
          })
        } else {
          this.$toast.fail('当前审批单暂无审批页面');
        }
      }

      if(this.isPiLiang) {
        this.$nextTick(()=>{
          if(this.dataList[index].businessTable !== 'wuye_infacy_main') {
            this.$refs.checkbox[index].toggle()
          } else {
            this.$toast.fail('批量审批暂不支持该流程!');
          }
        })
      }
    },
    changeShow(value){
      this.show = value
    },
    sliceName(value) {
      if(value.length <= 2) {
        return value
      } else {
        return value.slice(-2)
      }
    },
    changeColor(time){
      if(time.includes('天')) {
        return 'red'
      } else if(time.includes('时') && !time.includes('天')) {
        return 'yellow'
      } else if(!time.includes('时') && !time.includes('天')) {
        return 'green'
      }
    },
    clearResult(){
      this.result = []
    },
    showApproval(){
      if(this.result.length > 0) {
        this.auditForm.message = ''
        this.auditForm.type = '_flow_agree'
        this.auditForm.userIds = null
        this.auditForm.assignee = null
        this.auditForm.status = '同意'
        this.isMessage = false
        this.errNum = 0
        this.successNum = 0
        this.percentage = 0
        this.approvalShow = true
      } else {
        this.$toast.fail('请选择需要批量审批的数据')
      }
    },
    beforeClose(action, done){
      if(this.isMessage) {
        done(false)
      } else {
        done()
      }
    },
    submitTask(){
      let _this = this
      // this.$toast.loading({
      //   message: '加载中...',
      //   forbidClick: true,
      // });
      if(this.auditForm.status === '不同意' && !_this.auditForm.message) {
          this.isMessage=true
      } else {
        _this.$dialog.confirm({
          title: '系统提醒',
          message: `批量审批提交${this.result.length}条`,
        }).then(()=>{
          this.approvalShow = false
          this.progressShow = true
          if (this.auditForm.status == '同意') {
            this.agree()
          } else {
            this.reject()
          }
        })
      }
    },
    async agree(){
      let _this = this
      for (const  [num, item] of this.result.entries()) {
        try {
          if(item.type === "3") {
            let flowParam = {
              id: item.procInsId,
              businessId: item.businessId,
              approvalStatus: '2',
              approvalOpinion: _this.auditForm.message,
            }
            await new auditService().materFlowConfirm(flowParam)
            _this.percentage = (( num + 1) / _this.result.length * 100).toFixed(2)
            _this.successNum++
            if(num === _this.result.length - 1) {
              this.resultDialog = true
            }
          } else if(item.type === "7") {
            let url = ''
            let form = {}
            if(item.businessTable === 'its_sales_foreign_sales_order') {
              url='/sales/itsSalesForeignSalesOrder/startFlow'
              form = {
                id: item.businessId,
                flowType: item.isLastTask ? 4 : 2,
                formKey: item.formKey
              }
            } else if(item.businessTable === 'its_sales_foreign_sales_settlement') {
              url='/sales/itsSalesForeignSalesSettlement/startFlow'
              form = {
                id: item.businessId,
                flowType: item.isLastTask ? 4 : 2,
                formKey: item.formKey
              }
            }else if(item.businessTable === 'its_sales_outer') {
              url='/its/sales/itsSalesOuter/startFlow'
              form = {
                id: item.businessId,
                flowType: item.isLastTask ? 4 : 2,
                formKey: item.formKey
              }
            } else if(item.businessTable === 'its_sales_inner') {
              url='/its/sales/itsSalesInner/startFlow'
              form = {
                id: item.businessId,
                flowType: item.isLastTask ? 4 : 2,
                formKey: item.formKey
              }
            } else {
              url = '/its/comm/flow/startFlow'
              form = {
                id: item.businessId,
                flowType: item.isLastTask ? 4 : 2,
                formKey: item.formKey,
                flowTable: item.businessTable
              }
            }
            _this.auditForm.type = item.isLastTask ? '_flow_approval' : '_flow_agree'

            await new TaskService().audit({
              taskId: item.taskId,
              taskDefKey: item.taskDefKey,
              procInsId: item.procInsId,
              procDefId: item.procDefId,
              businessId: item.businessId,
              comment: _this.auditForm,
              assignee: _this.auditForm.assignee
            })
            await _this.$flow.startFlow(form, url);
            if(item.businessTable === 'its_contract') {
              await  _this.$flow.startFlow({
                id: item.businessId,
                flowType: item.isLastTask ? 4 : 2,
              }, '/contract/costContractInfo/startFlow')
              // const res = await _this.$flow.queryById(item.businessId, '/contract/costContractInfo/queryById')
              // if(res.data.contractCategory == 9 && res.data.businessType) {
              //
              // }
            }
            _this.percentage = (( num + 1) / _this.result.length * 100).toFixed(2)
            _this.successNum++
            if(num === _this.result.length - 1) {
              this.resultDialog = true
            }
          } else {
            let url = ''
            if(item.businessTable === 'cost_request_funds') {
              switch (item.formKey) {
                case '/cost/contractRequestFunds/CostContractRequestFundsFlowForm':
                  url = '/payment/costContractRequestFunds/startFlow'
                  break;
                case '/cost/eventRequestFunds/CostEventRequestFundsFlowForm':
                  url = '/payment/costEventRequestFunds/startFlow'
                  break;
                default:
                  url = '/payment/costEventClaim/startFlow'
              }
            } else if(item.businessTable === 'cost_contract_workload_estimate'){
              switch (item.formKey) {
                case '/cost/contractWorkloadEstimate/CostContractWorkloadEstimateFlowForm':
                  url = '/contract/costContractWorkloadEstimate/startFlow'
                  break;
                case '/cost/event/CostEventWorkloadEstimateFlowForm':
                  url = '/event/costContractWorkloadEstimate/startFlow'
                  break;
              }
            } else {
              let index = URLS.findIndex(x => x.name === item.businessTable)
              url = index > -1 ? URLS[index].url : ''
            }
            _this.auditForm.type = item.isLastTask ? '_flow_approval' : '_flow_agree'

            await new TaskService().audit({
              taskId: item.taskId,
              taskDefKey: item.taskDefKey,
              procInsId: item.procInsId,
              procDefId: item.procDefId,
              businessId: item.businessId,
              comment: _this.auditForm,
              assignee: _this.auditForm.assignee
            })
            let form = {
              id: item.businessId,
              flowType: item.isLastTask ? 4 : 2,
              formKey: item.formKey,
              flowTable: item.businessTable
            }
            await _this.$flow.startFlow(form, url);
            _this.percentage = (( num + 1) / _this.result.length * 100).toFixed(2)
            _this.successNum++
            if(num === _this.result.length - 1) {
              this.resultDialog = true
            }
          }
        } catch (e) {
          // console.log(e)
          _this.errNum++
          _this.percentage = (( num + 1) / _this.result.length * 100).toFixed(2)
          if(num === _this.result.length - 1) {
            this.resultDialog = true
          }
        }
      }
    },
    async reject(){
      let _this = this
      for (const  [num, item] of this.result.entries()) {
        try {
          if(item.type === "3") {
            let flowParam = {
              id: item.procInsId,
              businessId: item.businessId,
              approvalStatus: '3',
              approvalOpinion: _this.auditForm.message,
            }
            await new auditService().materFlowConfirm(flowParam)
            _this.percentage = (( num + 1) / _this.result.length * 100).toFixed(2)
            _this.successNum++
            if(num === _this.result.length - 1) {
              this.resultDialog = true
            }
          } else if(item.type === "7") {
            let url = ''
            let form = {}
            if(item.businessTable === 'its_sales_foreign_sales_order') {
              url='/sales/itsSalesForeignSalesOrder/startFlow'
              form = {
                id: item.businessId,
                flowType: 3,
                formKey: item.formKey
              }
            } else if(item.businessTable === 'its_sales_foreign_sales_settlement') {
              url='/sales/itsSalesForeignSalesSettlement/startFlow'
              form = {
                id: item.businessId,
                flowType: 3,
                formKey: item.formKey
              }
            } else if(item.businessTable === 'its_sales_outer') {
              url='/its/sales/itsSalesOuter/startFlow'
              form = {
                id: item.businessId,
                flowType: 3,
                formKey: item.formKey
              }
            } else if(item.businessTable === 'its_sales_inner') {
              url='/its/sales/itsSalesInner/startFlow'
              form = {
                id: item.businessId,
                flowType: 3,
                formKey: item.formKey
              }
            } else {
              url = '/its/comm/flow/startFlow'
              form = {
                id: item.businessId,
                flowType: 3,
                formKey: item.formKey,
                flowTable: item.businessTable
              }
            }

            await new ProcessService().stop(item.procInsId, _this.auditForm.message)
            await _this.$flow.startFlow(form, url);
            if(item.businessTable === 'its_contract') {
              await  _this.$flow.startFlow({
                id: item.businessId,
                flowType: 3,
              }, '/contract/costContractInfo/startFlow')
              // const res = await _this.$flow.queryById(item.businessId, '/contract/costContractInfo/queryById')
              // if(res.data.contractCategory == 9 && res.data.businessType) {
              //   await _this.$flow.startFlow2(form, '/its/contract/cost/startFlow')
              // }
            }
            _this.percentage = (( num + 1) / _this.result.length * 100).toFixed(2)
            _this.successNum++
            if(num === _this.result.length - 1) {
              this.resultDialog = true
            }
          } else {
            let url = ''
            if(item.businessTable === 'cost_request_funds') {
              switch (item.formKey) {
                case '/cost/contractRequestFunds/CostContractRequestFundsFlowForm':
                  url = '/payment/costContractRequestFunds/startFlow'
                  break;
                case '/cost/eventRequestFunds/CostEventRequestFundsFlowForm':
                  url = '/payment/costEventRequestFunds/startFlow'
                  break;
                case '/cost/claim/CostCommonClaimFlowForm':
                  url = '/payment/costEventClaim/startFlow'
                  break;
              }
            } else {
              let index = URLS.findIndex(x => x.name === item.businessTable)
              url = index > -1 ? URLS[index].url : ''
            }
            await new ProcessService().stop(item.procInsId, _this.auditForm.message)
            let form = {
              id: item.businessId,
              flowType: 3,
              formKey: item.formKey,
              flowTable: item.businessTable
            }
            await _this.$flow.startFlow(form, url);
            _this.percentage = (( num + 1) / _this.result.length * 100).toFixed(2)
            _this.successNum++
            if(num === _this.result.length - 1) {
              this.resultDialog = true
            }
          }
        } catch (e) {
          // console.log(e)
          _this.errNum++
          _this.percentage = (( num + 1) / _this.result.length * 100).toFixed(2)
          if(num === _this.result.length - 1) {
            this.resultDialog = true
          }
        }
      }
    },
    // 展示批量审批结果,并刷新页面
    showResult(){
      this.progressShow = false
      this.current = 1
      this.size = 10
      this.refreshList()
      // this.$toast.clear();
      this.result = []
    },
    changeMultipule(){
      let sjplsp = Vue.cookie.get('sjplsp')
      if(sjplsp === '1'){
        this.isPiLiang = true
      } else {
        this.isPiLiang = true
      }
    },
    cancelMultiple(){
      this.isPiLiang = false
      this.result = []
      // alert('1212')
    }
  }
}
</script>

<style scoped>

.doTask1{
  background-color: ghostwhite;padding: 10px;margin-top: 10px;
}

.content {
  width: 100%;
  height: calc(100vh - 200px - env(safe-area-inset-bottom));
  margin-top: 100px;
  /*margin-bottom: 65px;*/
  position: relative;
}

.content-item {
  width: 100%;
  height: 110px;
  background-color: #fff;
  display: flex;
  border-bottom: 1px solid #ececec;
}

.content-item-user {
  display: flex;
  width: 60px;
  height: 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.content-item-user-name {
  margin-top: 10px;
  font-size: 14px;
}

.content-item-center {
  flex: 1;
  margin-left: 10px;
  position: relative;
  /*display: flex;*/
  /*flex-direction: column;*/
  /*justify-content: flex-start;*/
}

.content-item-center-title {
  margin-top: 5px;
  font-size: 16px;
  font-weight: bold;
  max-width: 300px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出容器的部分内容 */
  text-overflow: ellipsis; /* 显示省略号 */
}

.content-item-center-content {
  /*margin-top: 10px;*/
  font-size: 15px;
  /*font-weight: bold;*/
  max-width: 300px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出容器的部分内容 */
  text-overflow: ellipsis; /* 显示省略号 */
}

.content-item-center-tips {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}

.content-item-center-tips-status {
  font-size: 14px;
  margin-top: 5px;
  color: #BD3124;
}

.content-item-center-tips-days {
  font-size: 14px;
  width: 170px;
  height: 20px;
  text-align: left;
  line-height: 20px;
  margin-top: 5px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出容器的部分内容 */
  text-overflow: ellipsis; /* 显示省略号 */
  /*margin-left: 15px;*/
  /*border: 1px solid #000;*/
  /*border-radius: 20px;*/
}

.content-item-right {
  width: 100px;
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
  align-items: center;
  margin-right: 20px;
}

.content-item-right-date {
  /*margin-top: 30px;*/
  font-size: 15px;
}

.avatar {
  width: 50px;
  height: 50px;
  background-color: #0093FF; /* 默认背景色 */
  border-radius: 50%; /* 圆角效果 */
  display: flex;
  align-items: center;
  justify-content: center;
}

#avatarText {
  font-size: 18px;
  color: #fff; /* 文字颜色 */
}

.red {
  color: #ee0a24;
}

.yellow {
  color: #E6A23C;
}

.green {
  color: #67C23A;
}

.selectMul {
  width: 100%;
  padding-left: 20px;
  /*padding-right: 20px;*/
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  position: fixed;
  bottom: calc(50px + env(safe-area-inset-bottom));
  left: 0;
  border-top: 1px solid #ececec;
  /*z-index: 9999;*/
}

.confirm {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  background-color: #fff;
  position: fixed;
  bottom: calc(50px + env(safe-area-inset-bottom));
  left: 0;
  font-size: 18px;
  border-top: 1px solid #ececec;
}

</style>

<style>
.van-list {
  min-height: calc(100vh - 220px);
}
</style>
